var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTechRightAngular(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2167_26579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.00952 10.6847L19.9603 6.07031L33.2599 10.6026L31.1065 27.7372L19.9603 33.9101L8.98857 27.8192L7.00952 10.6847Z",
    fill: "#E23237"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2598 10.6026L19.9602 6.07031V33.9101L31.1064 27.7475L33.2598 10.6026Z",
    fill: "#B52E31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9808 9.32031L11.9109 27.2752L14.9255 27.2239L16.5457 23.1735H23.7851L25.559 27.2752L28.4404 27.3265L19.9808 9.32031ZM20.0013 15.0729L22.7289 20.7741H17.6018L20.0013 15.0729Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2167_26579"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.3536,
    height: 28,
    fill: "white",
    transform: "translate(6.99878 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechRightAngular);
export default __webpack_public_path__ + "static/media/tech-right-angular.5e3692e0675af8b423943de9155019e5.svg";
export { ForwardRef as ReactComponent };